import { Box } from '@mui/material';
import { Suspense, lazy } from 'react';
import type { PlotProps } from './PlotImpl';

const LazyPlot = lazy(() => import('./PlotImpl').then((m) => ({ default: m.Plot })));

export const Plot = (props: PlotProps) => (
  <Suspense fallback={<Box />}>
    <LazyPlot {...props} />
  </Suspense>
);
